import { track } from 'src/utils/track'

function fireShare (method, contentType, contentId) {
  // GA4 标准 share event
  try {
    track('share', {
      method: method || 'facebook',
      content_type: contentType,
      item_id: contentId ? String(contentId) : undefined
    })
  } catch (e) {}
}

export default {
  methods: {
    FBInvite (uid) {
      this.checkoutFB().then(data => {
        window.FB.ui({
          method: 'share',
          href: this.$store.state.language === 'jp' ? `https://ipastbook.com/jp/?sourceId=${uid}` : `${window.location.origin}/?sourceId=${uid}`,
          hashtag: this.$store.state.language === 'jp' ? '#iPastBook JP' : '#iPastBook'
        }, (res) => {
          fireShare('facebook', 'invite_host', uid)
        })
      })
    },
    FBShareBook (bid) {
      this.checkoutFB().then(data => {
        window.FB.ui({
          method: 'share',
          href: `${window.location.origin}/book/?bid=${bid}`,
          hashtag: this.$store.state.language === 'jp' ? '#iPastBook JP' : '#iPastBook'
        }, (res) => {
          fireShare('facebook', 'book', bid)
        })
      })
    },
    FBShareGroup (gid) {
      this.checkoutFB().then(data => {
        window.FB.ui({
          method: 'share',
          href: `${window.location.origin}/group/start/?gid=${gid}`,
          hashtag: this.$store.state.language === 'jp' ? '#iPastBook JP' : '#iPastBook'
        }, (res) => {
          fireShare('facebook', 'group', gid)
        })
      })
    },
    FBShareGroups (ref) {
      this.checkoutFB().then(data => {
        window.FB.ui({
          method: 'share',
          href: `${window.location.origin}/groups?ref=${ref}`,
          hashtag: this.$store.state.language === 'jp' ? '#iPastBook JP' : '#iPastBook'
        }, (res) => {
          fireShare('facebook', 'official_groups', ref)
        })
      })
    },
    checkoutFB () {
      return new Promise((resolve, reject) => {
        if (!window.FB) {
          this.$toast({
            message: this.$t('invitation.tipInvitationFailed'),
            position: 'bottom'
          })
          return reject(new Error('Facebook SDK not loaded'))
        }
        return resolve(true)
      })
    }
  }
}
